import ResetPinPage from './ResetPin';

export default ResetPinPage;